var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Detalles del flujo para el Expediente " + _vm.file.numero,
        "ok-title": "Vale",
        size: "lg",
        "ok-only": ""
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _vm.fileOnFlow.detalle &&
          _vm.fileOnFlow.detalle.documentosBase &&
          _vm.fileOnFlow.detalle.documentosBase.length
            ? _c("h4", [
                _vm._v(
                  " Detalles del Flujo para el documento " +
                    _vm._s(
                      _vm.fileOnFlow.detalle.documentosBase[0].objetoNombre
                    ) +
                    " "
                )
              ])
            : _vm._e()
        ]),
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            { staticClass: "row mb-3" },
            [
              _c("h5", { staticClass: "col-12 mt-4" }, [
                _vm._v(" Archivos adjuntos ")
              ]),
              _c(
                "vs-table",
                {
                  staticClass: "col-12 box-attachments",
                  attrs: {
                    stripe: "",
                    data: _vm.fileOnFlowAttachments || [],
                    noDataText: "No hay documentos"
                  }
                },
                [
                  _c("template", { slot: "header" }),
                  _c(
                    "template",
                    { slot: "thead" },
                    [
                      _c("vs-th", [_vm._v(" Nombre Adjunto ")]),
                      _c("vs-th", [_vm._v(" Tipo ")]),
                      _c("vs-th", [_vm._v(" Ver ")])
                    ],
                    1
                  ),
                  [
                    _c(
                      "tbody",
                      _vm._l(_vm.fileOnFlowAttachments, function(attachment) {
                        return _c(
                          "vs-tr",
                          { key: attachment.url },
                          [
                            _c("vs-td", [
                              _vm._v(
                                " " + _vm._s(attachment.nombreCompleto) + " "
                              )
                            ]),
                            _c("vs-td", [
                              attachment.esInicial
                                ? _c("span", [_vm._v(" principal ")])
                                : _vm._e(),
                              !attachment.esInicial
                                ? _c("span", [_vm._v(" adjunto ")])
                                : _vm._e()
                            ]),
                            _c("vs-td", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    width: "fit-content"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.selectFile(attachment)
                                    }
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { icon: "FileTextIcon", size: "14" }
                                  })
                                ],
                                1
                              )
                            ])
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ]
                ],
                2
              )
            ],
            1
          ),
          _c("div", {}, [
            _c(
              "div",
              { staticClass: "col-6" },
              _vm._l(_vm.numPages, function(i) {
                return _c("pdf", {
                  key: i,
                  staticClass: "mt-2",
                  attrs: { page: i, src: _vm.selectedFile }
                })
              }),
              1
            )
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c("h5", { staticClass: "my-3" }, [_vm._v(" Pasos ")]),
            _vm.fileOnFlow.detalle && _vm.fileOnFlow.detalle.pasos
              ? _c("Steps", {
                  attrs: {
                    steps: _vm.fileOnFlow.detalle.pasos,
                    ejecucion: _vm.fileOnFlow.detalle.ejecucion
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c("h5", { staticClass: "my-3" }, [_vm._v(" Bitácora ")]),
            _vm.binnacleFile.length ? _c("binnacle") : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }